import totalTickets from '../../../assets/icons/TotalAssessmentIcon.svg';
import pendingTickets from "../../../assets/icons/pendingTicketIcon.svg";
import closedTickets from '../../../assets/icons/ClosedTIcketIcon.svg';
import inprogressTickets from '../../../assets/icons/TotalTimeTakenIcon.svg';
import TicketRaisedChart from './chart/TIcketRaisedChart';
import TicketCategoriesChart from './chart/TIcketCategoriesChart';
import RecentTickets from './chart/RecentTicketsChart';
import TicketStatCard from './TicketStatCard';
import TicketDashboardService from "../../../services/TicketDashboardService";
import { useCallback, useContext, useEffect, useState } from 'react';
import AuthContext from '../../../auth/AuthContext';
import { useNavigate } from 'react-router-dom';
import AlertService from '../../../services/AlertService';

const TicketDashboard = () => {
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(true); 

  const ticketAccess = authContext.getPermissions("ticketdashboard");
  if (ticketAccess.filter((f) => f.access.includes(1)).length === 0) {
    navigate("/");
  }

 const loadDashboard = useCallback(async (signal) => { 
    setLoading(true);
    try {
      const data = await TicketDashboardService.GetDashboard(
        authContext,
        signal
      );

      if (signal?.aborted) return;

      if (data.isSuccess) {
        setCardData([
          { title: "Total Tickets", value: data.data.totalTickets, icon: totalTickets, bgColor: "#EBF1F3", status: 0 },
          { title: "Pending Tickets", value: data.data.pending, icon: pendingTickets, bgColor: "#DCF6E0", status: 1 },
          { title: "Closed Tickets", value: data.data.closed, icon: closedTickets, bgColor: "#E3CFCF", status: 3 },
          { title: "Tickets In Progress ", value: data.data.inProgress, icon: inprogressTickets, bgColor: "#F6EED9", status: 2 },
        ]);
      } else {
        AlertService.error(data.errorMessage);
      }
    } catch (err) {
      if (err.name === "AbortError") return;
    } finally {
      if (!signal?.aborted) setLoading(false);
    }
  }, [authContext]);

useEffect(() => {
    const controller = new AbortController();
    loadDashboard(controller.signal);
    return () => controller.abort(); 
  }, [loadDashboard]);
  
  const handleCardClick = (status) => {
    navigate(`/assigned-tickets/tickets?status=${status}`);
  };

  return (
    <div className="container-fluid mt-3 pt-3 mb-3">
      <div className="row g-3 align-items-stretch">
        <div className="col-xl-6 col-md-12 ">
          <div className="row g-3">
           {(loading ? Array.from({ length: 4 }) : cardData).map((card, idx) => (
              <div key={idx} className="col-12 col-md-6">
                <div onClick={() => handleCardClick(card.status)} style={{cursor: loading ? "default" : "pointer",  }}>
                  <TicketStatCard {...card} loading={loading}  />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="col-xl-6 col-md-12 d-flex flex-column">
          <TicketRaisedChart />
        </div>
      </div>
      <div className="row g-3 align-items-stretch mt-2">
        <div className="col-xl-5 col-md-12">
          <TicketCategoriesChart />
        </div>
        <div className="col-xl-7 col-md-12">
          <RecentTickets />
        </div>
      </div>
    </div>
  );
};

export default TicketDashboard;
